export const PAGE_TYPES = {
  HOME: 'NetC.PitstopHome',
  HOW_IT_WORKS: 'NetC.PitstopHowItWorks',
  FIND_AN_EVENT: 'NetC.PitstopFindAnEvent',
  PRIZES: 'NetC.PitstopPrizes',
  GALLERY: 'NetC.PitstopGallery',
  M12_STUBBY_WRENCH: 'NetC.PitstopStubbyWrench',
};
